export default __webpack_public_path__ + "static/media/14_Zajic_polni_PELZ_upr.343106d9.mp3";